import stringInject from 'stringinject'
import {DOCUMENT_VERSION, GROUP_DOCUMENT_VERSION} from '../config/config_api_backend'
import http from '../plugins/http'

const apiGetLatestVersion = async (slug) => {
    try {
        let url = stringInject(DOCUMENT_VERSION.GET_LATEST_VERSION, {'slug': slug})
        let response = await http.get(url)
        return response.data
    } catch (e) {

        if (e.response && e.response.status !== 204) return null
        else return ''
    }
}

const apiGetLatestGroupVersion = async (slug) => {
    try {
        let url = stringInject(GROUP_DOCUMENT_VERSION.GET_LATEST_VERSION, {'slug': slug})
        let response = await http.get(url)
        return response.data
    } catch (e) {

        if (e.response && e.response.status !== 204) return null
        else return ''
    }
}

const apiGetAllVersion = async (slug) => {
    try {
        let url = stringInject(DOCUMENT_VERSION.GET_ALL_VERSION, {'slug': slug})
        let response = await http.get(url)
        return response.data
    } catch (e) {

        if (e.response && e.response.status !== 204) return null
        else return ''
    }
}

const apiGetVersion = async (slug, version) => {
    try {
        let url = stringInject(DOCUMENT_VERSION.GET_VERSION, {'slug': slug, 'version': version})
        let response = await http.get(url)
        return response.data
    } catch (e) {

        if (e.response && e.response.status !== 204) return null
        else return ''
    }
}

export {
    apiGetLatestVersion,
    apiGetAllVersion,
    apiGetVersion,
    apiGetLatestGroupVersion
}
